import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

interface BreadcrumbItem {
  label: string;
  href?: string;
}

export function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  const { t } = useTranslation();
  return (
    <nav aria-label="breadcrumb" className="w-full bg-background-100/70 border-b border-background-200/70 animate-fade-in">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-3">
        <ol className="flex items-center gap-2 text-sm text-foreground-700">
          <li>
            <a href="/" className="relative inline-block hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap font-medium after:absolute after:bottom-0 after:left-0 after:h-[1.5px] after:w-full after:bg-primary-500 after:origin-left after:scale-x-0 hover:after:scale-x-100 after:transition-transform after:duration-300 after:ease-out">{t("breadcrumb.home")}</a>
          </li>
          {items.map((item, i) => (
            <li key={i} className="flex items-center gap-2">
              <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center text-foreground-500"></i>
              {item.href ? (
                <a href={item.href} className="relative inline-block hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap font-medium after:absolute after:bottom-0 after:left-0 after:h-[1.5px] after:w-full after:bg-primary-500 after:origin-left after:scale-x-0 hover:after:scale-x-100 after:transition-transform after:duration-300 after:ease-out">{item.label}</a>
              ) : (
                <span className="text-foreground-900 font-semibold whitespace-nowrap">{item.label}</span>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
}

export default function PageShell({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>{children}</main>
      <Footer />
    </div>
  );
}